/* src/app/modules/shared/components/topbar/topbar.component.scss */
.topbar {
  background-color: #ffffff;
  color: #073b70;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.topbar .menu-toggle {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.topbar h4 {
  font-size: 1.25rem;
  color: #343a40;
}
@media (max-width: 576px) {
  .topbar h4 {
    font-size: 1rem;
  }
  .topbar .menu-toggle {
    width: 30px;
    height: 30px;
  }
}
@media (max-width: 575.98px) {
  .topbar h4 {
    font-size: 1rem;
  }
  .topbar .position-relative,
  .topbar .d-flex.align-items-center.border {
    min-width: unset !important;
    max-width: 120px !important;
    padding: 0 4px !important;
  }
  .topbar .fw-semibold,
  .topbar .text-muted {
    display: none !important;
  }
  .topbar .fa-user-circle {
    font-size: 1.2rem !important;
  }
  .topbar .btn {
    padding: 0 4px !important;
  }
}
/*# sourceMappingURL=topbar.component.css.map */
